// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___bc42170361c4ba46d2c{/*!*/}.SimplePaperPodcast-cls2__d17afb627c69a24abc38{display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:#0645b1;border-radius:50%;color:#fff;flex-shrink:0;padding-left:4px;transition:all .15s ease}.SimplePaperPodcast-cls2__d17afb627c69a24abc38:hover{background:#2563eb;border-color:#2563eb}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___bc42170361c4ba46d2c",
	"cls2": "SimplePaperPodcast-cls2__d17afb627c69a24abc38 SimplePaperPodcast-cls1___bc42170361c4ba46d2c"
};
export default ___CSS_LOADER_EXPORT___;
